export default __webpack_public_path__ + "58f5017595ed2ea0b30103db2e9325e6.png";